import { render, staticRenderFns } from "./ChipLabel.vue?vue&type=template&id=7afc9f6a"
import script from "./ChipLabel.vue?vue&type=script&lang=ts"
export * from "./ChipLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports